import React, { useState, useCallback, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { MetadataContent } from '@jutro/uiconfig';
import { useDependencies } from 'gw-portals-dependency-react';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { useModal } from '@jutro/components';
import { AdacConfirmationModal } from 'gw-capability-fnol-adac-react';
import { ErrorCodes } from 'gw-portals-util-adac-js';
import { CommunicationVariablesContext } from 'gw-capability-fnol-adac-react';
import metadata from './AdacCallbackOptionsPage.metadata.json5';
import messages from './AdacCallbackOptionsPage.messages';
import standaloneMessages from './AdacCallbackOptionsPageStandalone.messages';
import styles from './AdacCallbackOptionsPage.module.scss';

function AdacCallbackOptionsPage(props) {
    const { history } = props;
    const [isLoading, setIsLoading] = useState(true);
    const viewModelService = useContext(ViewModelServiceContext);
    const [selectedOption, setSelectedOption] = useState();
    const [sent, setSent] = useState(false);
    const translator = useTranslator();
    const { ClaimService } = useDependencies('ClaimService');

    const { communicationVariables } = useContext(CommunicationVariablesContext)
    const { token, sessionUUID, communicationTypeExt } = communicationVariables;
    const { showModal } = useModal();

    const showModalAndGoBack = useCallback(async () => {
        await showModal(
            <AdacConfirmationModal
                icon="mi-info"
                message={translator(standaloneMessages.recallAlreadyPlanned)}
                confirmButtonText={translator(standaloneMessages.close)}
            />
        );
        history.goBack();
    }, [history, translator]);

    useEffect(() => {
        setIsLoading(true);
        ClaimService.hasOpenRecallActivity(token, sessionUUID)
            .then((isCreated) => {
                if (isCreated) {
                    showModalAndGoBack();
                }
            })
            .catch(() => {
                history.push({ pathname: '/trylater' });
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [ClaimService, history, sessionUUID, showModalAndGoBack, token]);

    const onNext = useCallback(() => {
        setIsLoading(true);
        const portalRecallOptionVM = viewModelService.create(
            {
                option: null,
                hours: selectedOption
            },
            'cc',
            'adac.edge.capabilities.claim.fnol.dto.PortalRecallOptionDTO'
        );

        ClaimService.handleRecall(portalRecallOptionVM.value, token, sessionUUID)
            .then(() => {
                setSent(true);
            })
            .catch((error) => {
                if (error.appErrorCode === ErrorCodes.SESSION_EXPIRED) {
                    history.push({
                        pathname: '/sessionexpired'
                    });
                } else {
                    history.push({ pathname: '/callcenter' });
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [viewModelService, selectedOption, ClaimService, token, sessionUUID, history]);

    const overrides = {
        adacCallbackOptionsPageLoader: {
            loaded: !isLoading
        },
        agreement: {
            visible: false
        },
        callOptionsCard: {
            value: selectedOption
        },
        backButton: {
            onClick: () => history.goBack()
        },
        nextButton: {
            disabled: !selectedOption,
            onClick: onNext
        },
        sentContainer: {
            visible: sent
        },
        adacCallbackOptionsContainer: {
            visible: !sent
        },
        description: {
            content: translator(standaloneMessages.pleaseHoldYourPhone, {
                option: translator(messages[`callback${selectedOption}`])
            })
        },
        finishButton: {
            onClick: () => history.push({
                pathname: '/history',
                state: {
                    token,
                    sessionUUID,
                    communicationTypeExt
                }
            })
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
        },
        resolveCallbackMap: {
            writePortalRecallOptionHours: setSelectedOption,
            onNext
        }
    };
    return <MetadataContent
        uiProps={metadata.pageContent}
        overrideProps={overrides}
        {...resolvers}
    />;
}

export default withRouter(AdacCallbackOptionsPage);
